export async function modifySubscription(email, action, extras ){  
  const url = `/api/eloqua/modifySubscriptionForm/${encodeURIComponent(email)}/${encodeURIComponent(action)}?isFromNews=${extras?.isFromNews ?? false}`;
  const response = await fetch(url);
  const  data = await response.json();
  return data.code == 200;
}